module.exports = __webpack_public_path__ + "img/sendall.aa19cce1.jpg";